module.exports = __webpack_public_path__ + "img/risotto-alla-milanese.1880b5af.png";